import React from 'react'
import './index.css'
import souhail from '../../../assets/images/souhail.PNG'
import taher from '../../../assets/images/tahar.PNG'
import aimen from '../../../assets/images/aimen.jfif'
import randa from '../../../assets/images/randa.jfif'
import wiwi from '../../../assets/images/wiwi.PNG'
const Testimonials = () => {
  return (
    <>
      <div class="body">
        <div class="testimonials">
          <div class="card card--bg-purple">
            <header class="card__header">
              <img src={souhail} class="card__img" alt="" />
              <div>
                <h3>Souhail HBAIEB</h3>
                <p>Senior Project Manager</p>
              </div>
            </header>
            <p class="card__lead">
              I highly recommend Nacer for any management position because he
              has all the qualities of a future manager!
            </p>
            <p class="card__quote">
              "I highly recommend Nacer for any management position because he
              has all the qualities of a future manager. He was among us in a
              PFE a little bit particular and futuristic for the Tunisian
              companies which think to be with the listening of their personnel
              and its role in the societal side. Good luck Nacer."
            </p>
          </div>

          <div class="card card--bg-gray-blue">
            <header class="card__header">
              <img src={taher} class="card__img" alt="" />
              <div>
                <h3>Tahar RAIS </h3>
                <p>IT Talent Acquisition Specialist</p>
              </div>
            </header>
            <p class="card__lead">
              Nacer is one of the most creative and dedicated coworkers I had!
            </p>
            <p class="card__quote">
              "Nacer is one of the most creative and dedicated coworkers I had,
              its not easy to find someone who would always give 100% efforts in
              their job description and even go the extra mile with a purpose in
              heart for doing the right things right."
            </p>
          </div>

          <div class="card card--bg-black-blue">
            <header class="card__header">
              <img src={randa} class="card__img" alt="" />
              <div>
                <h3>Randa JARRAYA</h3>
                <p>QHSE Manager</p>
              </div>
            </header>
            <p class="card__lead">
              Very detailed, focused and produced excellent results during his
              internship!
            </p>
            <p class="card__quote">
              "It was a pleasure to work with Nacer MEDIOUNI during his end of
              study INTERNSHIP in EPPM. He is very detailed, focused and
              produced excellent results during his internship. I wish him all
              the best for all his future endeavours and would not hesitate to
              recommend him to any recruiting company."
            </p>
          </div>

          <div class="card">
            <header class="card__header">
              <img src={aimen} class="card__img" alt="" />
              <div>
                <h3>Aimen KTARI</h3>
                <p>
                  Manager of social and environmental audits | University
                  Professor | EU Climate Ambassador 🇪🇺
                </p>
              </div>
            </header>
            <p class="card__lead">
              I was able to discover an assiduous, persevering and successful
              person!
            </p>
            <p class="card__quote">
              "Nacer is a dynamic student, he is very sensitive to the values of
              sustainable development in his daily life. Professionally I was
              his teacher and also his academic supervisor in 2018/2019, I was
              able to discover an assiduous, persevering and successful person.
              He ended up passing brilliantly his year and his final thesis on
              CSR in Tunisia."
            </p>
          </div>

          <div class="card card--bg-black-blue">
            <header class="card__header">
              <img src={wiwi} class="card__img" alt="" />
              <div>
                <h3>Wiem CHERNI</h3>
                <p>
                  Community Builder l Innovation Seeker l Startup Enthusiast
                  🚀🚀Community Builder l Innovation Seeker l Startup Enthusiast
                  🚀🚀
                </p>
              </div>
            </header>
            <p class="card__lead">
              Nacer has exceptional expertise in leadership, coaching and
              motivation!
            </p>
            <p class="card__quote">
              "Nacer has exceptional expertise in leadership, coaching and
              motivation. He was my president in an environmental project where
              I had the opportunity to learn a lot from him! He consistently
              demonstrated a solid work ethic ."
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Testimonials
